module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-bottom": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    },
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), (_vm.text) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "bottom": "0px",
      "background": "#8b0000",
      "color": "#fff",
      "font-size": "12px",
      "padding": "2px 6px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a3573a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/img-component.vue
// module id = 255
// module chunks = 1